import React from "react";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";

import "./styles.css";
import { useSetRecoilState } from "recoil";
import { popupState } from "../../../../Store/atoms";
import { PopupType } from "../../../../Models/Entities";

export interface IChooseAction {
  offsetX: number;
  offsetY: number;
}

export default ({ offsetX, offsetY }: IChooseAction) => {
  const setActivePopup = useSetRecoilState(popupState);

  const style = {
    top: offsetY,
    left: offsetX,
  };

  const close = (e: any) => {
    e.stopPropagation();
    setActivePopup(null);
  };

  const handleEdit = (e: any) => {
    close(e);
    setActivePopup({ type: PopupType.EditRecord, props: null });
  };

  const handleDuplicate = (e: any) => {
    close(e);
    setActivePopup({ type: PopupType.DuplicateRecord, props: null });
  };

  const handleDelete = (e: any) => {
    close(e);
    setActivePopup({ type: PopupType.DeleteRecord, props: null });
  };

  const handleCreate = (e: any) => {
    close(e);
    setActivePopup({ type: PopupType.AddRecord, props: null });
  };
  return (
    <div className="popup popup--record" style={style}>
      <div onClick={handleEdit} className="popup__item popup__item--edit">
        <EditIcon />
        <span className="item__desc">Edit</span>
      </div>

      <div onClick={handleDuplicate} className="popup__item">
        <FileCopyIcon />
        <span className="item__desc">Duplicate</span>
      </div>

      <div onClick={handleDelete} className="popup__item">
        <DeleteIcon />
        <span className="item__desc">Delete</span>
      </div>

      <div onClick={handleCreate} className="popup__item">
        <AddIcon />
        <span className="item__desc">Create</span>
      </div>
    </div>
  );
};
